import {HttpModelConverter} from '../../../../../../core/converter/httpModel.converter';
import {Scan3dGroupSummaryModel} from '../scan3dGroupSummary.model';
import {Injectable} from '@angular/core';
import {LovValueSummaryConverter} from '../../../../../../common/lov/lov-value/api/converter/LovValueSummary.converter';
import {PermissionsConverter} from '../../../../../../common/converter/permissions.converter';
import {PartnerSummaryConverter} from '../../../../../../partner/common/api/converter/partnerSummary.converter';
import {Scanner3dConverter} from '../../../../../scanner3d/common/api/entity/converter/scanner3d.converter';
import {UserSummaryConverter} from '../../../../../../account/modules/user/api/converter/userSummary.converter';

@Injectable()
export class Scan3dGroupSummaryConverter extends HttpModelConverter<Scan3dGroupSummaryModel> {

    constructor(private scanner3dConverter: Scanner3dConverter,
                private lovValueSummaryConverter: LovValueSummaryConverter) {
        super();
    }

    protected createInstance(): Scan3dGroupSummaryModel {
        return new Scan3dGroupSummaryModel();
    }

    protected enrichObject(result: Scan3dGroupSummaryModel, src: Scan3dGroupSummaryModel) {
        result.scanFormat = this.lovValueSummaryConverter.convert(src.scanFormat);
        result.scanMethod = this.lovValueSummaryConverter.convert(src.scanMethod);
        result.permissions = new PermissionsConverter().convert(src.permissions);
        result.partner = new PartnerSummaryConverter().convert(src.partner);
        result.scanner3D = this.scanner3dConverter.convert(src.scanner3D);
        result.footPosition = this.lovValueSummaryConverter.convert(src.footPosition);
        result.objectType = this.lovValueSummaryConverter.convert(src.objectType);
        result.referencial = this.lovValueSummaryConverter.convert(src.referencial);
        result.createdBy = new UserSummaryConverter().convert(src.createdBy);
        result.updatedBy = new UserSummaryConverter().convert(src.updatedBy);
    }

}
